export const AD_BREAK = 1550
export const APPLE = 'apple'
export const GOOGLE = 'google'
export const APPLE_URL = 'https://apps.apple.com/us/app/homebot'
export const GOOGLE_URL =
  'https://play.google.com/store/apps/details?id=com.homebot.app'
